import Newsletter from 'components/contentBlocks/Newsletter';
import PropTypes from 'prop-types';
import React from 'react';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import transformNewsletterForm from 'libs/wordpress/utils/transformNewsletterForm';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

// Pure CMS data transformation before we send it to the "real" block!
const NewsletterBlock = ({ content, moduleTextColor = 'black' }) => {
    const { heading, newsletter_form: newsletterForm, paragraph } = content;

    // Transform form data
    const formData = transformNewsletterForm(newsletterForm);

    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;

    return (
        <Newsletter
            form={formData}
            formTheme={moduleTextColor}
            heading={decodeHTMLEntities(heading?.text)}
            headingSize="lg"
            headingTag={heading?.type}
            text={paragraph}
            textColor={textColor}
        />
    );
};

NewsletterBlock.propTypes = {
    content: PropTypes.shape({
        heading: PropTypes.object,
        'newsletter_form': PropTypes.object.isRequired,
        paragraph: wysiwygProp,
    }).isRequired,
    moduleTextColor: PropTypes.string,
};

export default NewsletterBlock;
